import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { Card } from '../ui/Card';
import { classNames } from '../../utils/classNames';

interface MetricCardProps {
  label: string;
  value: string | number;
  delta?: string;
  deltaType?: 'positive' | 'negative' | 'neutral';
  icon?: React.ReactNode;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  delta,
  deltaType = 'neutral',
  icon,
}) => {
  const renderDeltaIcon = () => {
    switch (deltaType) {
      case 'positive':
        return <TrendingUp className="w-4 h-4 text-emerald-400" />;
      case 'negative':
        return <TrendingDown className="w-4 h-4 text-red-400" />;
      default:
        return <Minus className="w-4 h-4 text-slate-400" />;
    }
  };

  const deltaColorClass = {
    positive: 'text-emerald-400',
    negative: 'text-red-400',
    neutral: 'text-slate-400',
  }[deltaType];

  return (
    <Card className="text-center hover:transform hover:scale-105 transition-all duration-200 group h-full">
      <div className="flex flex-col items-center justify-between h-full min-h-[140px] py-4">
        {icon && (
          <div className="w-12 h-12 rounded-2xl theme-bg-metric-icon backdrop-blur-sm flex items-center justify-center border theme-border-metric-icon group-hover:border-slate-500/50 transition-all duration-200 flex-shrink-0">
            {icon}
          </div>
        )}
        
        <div className="flex-1 flex flex-col justify-center px-2">
          <p className="text-sm font-medium theme-text-metric-label mb-1 leading-tight">{label}</p>
          <p className="text-2xl font-bold theme-text-metric-value leading-none">{value}</p>
        </div>
        
        {delta && (
          <div className={classNames(
            'flex items-center space-x-1 text-sm font-medium flex-shrink-0 theme-text-metric-delta'
          )}>
            {renderDeltaIcon()}
            <span>{delta}</span>
          </div>
        )}
      </div>
    </Card>
  );
};